import type { TUser } from '@shared/types/user';
import type { TDocument } from '@shared/types/document';
import type { TOrganization } from '@shared/types/organization';
import type { TProgram } from '@shared/types/program';
import type { TStage } from '@shared/types/stage';
import type { TField } from '@shared/types/field';
import type { ValueOf } from './utilities';

export const FLIGHT_TYPES = {
  destination: 'DESTINATION',
  return: 'RETURN',
} as const;

export type TFlightType = ValueOf<typeof FLIGHT_TYPES>;

export const RULE_TYPES = {
  payment: 'PAYMENT',
  trueFalse: 'TRUE_FALSE',
  date: 'DATE',
  meeting: 'MEETING',
  programQuestion: 'PROGRAM_QUESTION',
  documentType: 'DOCUMENT_TYPE',
  applicationSubmission: 'APPLICATION_SUBMISSION',
  flightInfo: 'FLIGHT_INFO',
} as const;

export type TRule = {
  id: number;
  flight_type: TFlightType;
  stage: TStage;
  program: TProgram;
  question: TField;
  program_document: TDocument;
  created_by: TUser;
  organization: TOrganization;
  created_at: string;
  updated_at: string;
  name: string;
  type: ValueOf<typeof RULE_TYPES>;
  choices: string[];
  achieving_criterion: string;
  is_required: boolean;
  is_crm_only: boolean;
  metadata: string;
  description: string;
  order: number;
};
